module.exports = __webpack_public_path__ + "static/media/pesu.287cfdba.png";